"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSidebar = void 0;
const ui_1 = require("@app/component/ui");
const modal_sidebar_button_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-button");
const modal_sidebar_container_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-container");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("../calendar-settings-context");
const CSSidebar = () => {
    const { selectedTab, setSelectedTab, calendarSettingsTabs } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    const filteredTopTabs = react_1.default.useRef(calendarSettingsTabs.filter((tab) => (0, util_1.isUndefined)(tab.position) || tab.position === 'top'));
    const filteredBottomTabs = react_1.default.useRef(calendarSettingsTabs.filter((tab) => (0, util_1.isDefined)(tab.position) && tab.position === 'bottom'));
    return (react_1.default.createElement(modal_sidebar_container_1.ModalSidebarContainer, null,
        filteredTopTabs.current.map((tab) => (react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { key: tab.id, selected: selectedTab === tab.value, ico: tab.ico, onClick: () => setSelectedTab(tab.value) },
            react_1.default.createElement(ui_1.Text, { type: 'body-large', color: 'inherit', weight: selectedTab === tab.value ? 'bold' : 'medium' }, tab.label)))),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'end',
                flexDirection: 'column',
                gap: '0.5rem',
                height: '100%',
            } },
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'computer', selected: selectedTab === 'dev', onClick: () => setSelectedTab('dev') },
                react_1.default.createElement(ui_1.Text, { type: 'body-large', color: 'inherit', weight: selectedTab === 'dev' ? 'bold' : 'medium' }, "DEV")),
            react_1.default.createElement("div", { style: {
                    height: '1.645rem',
                    display: 'flex',
                    alignItems: 'center',
                } },
                react_1.default.createElement(ui_1.Button, { size: 'FULL', style: selectedTab === 'delete-shifts' ? 'CONTAINED' : 'BORDERLESS', color: 'RED', onClick: () => setSelectedTab('delete-shifts') },
                    react_1.default.createElement("span", { style: {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            paddingInline: '0.625rem',
                            boxSizing: 'border-box',
                            gap: '0.5rem',
                        } },
                        react_1.default.createElement(ui_1.Icon, { size: 'small', ico: 'delete', color: 'inherit' }),
                        (0, util_1.t)('OFF_TYPE_DELETE_MULTI')))),
            filteredBottomTabs.current.map((tab) => (react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { key: tab.id, selected: selectedTab === tab.value, ico: tab.ico, onClick: () => setSelectedTab(tab.value) },
                react_1.default.createElement(ui_1.Text, { type: 'body-large', color: 'inherit', weight: selectedTab === tab.value ? 'bold' : 'medium' }, tab.label)))))));
};
exports.CSSidebar = CSSidebar;
